export class BasicAuth {
  _t = 'BasicAuth';
  userName = '';
  password = '';
  tokenEncoded = false;
}
